import React, { Component, useContext, useState, useEffect, useCallback } from 'react'
import { Row, Col, Form, Input, Button, Card, Spin, Divider, Alert, Modal, Typography } from 'antd';
import { UserOutlined, MailOutlined, PhoneOutlined, BankOutlined, ApartmentOutlined, LockOutlined } from '@ant-design/icons';
import { Redirect, Link } from "react-router-dom";
import { User, SetUser } from '../../Hooks/Logged';
import '../../Styles/Global/auth.css';
import Recovery from './Recovery';


import ReCAPTCHA from "react-google-recaptcha";

const axios = require("axios").default;
const { Text } = Typography



/**
 *
 *
 * @class Register
 * @extends {Component}
 */
class Register extends Component {

    script = React.createRef();

    redirectLink = "/admin/dashboard";


    /**
     *Creates an instance of Register.
     * @param {*} props
     * @memberof Register
     */
    constructor(props) {
        super(props);
        this.state = {
            log: false,
            loading: false,
            error: {
                success: null,
                message: null
            },
            modalRegisterVisible: false,
            type: this.props.type,


            visibleRobot: false
        }
    }



    /**
     * @memberof Register
     *
     * @method handleSubmit
     * @description  Envia los datos del formulario al Servidor
     *
     * @param values (array)
     * Contiene los campos del formulario para registrar al usuario
     *
     * @returns response (array)
     **/
    handleSubmit = (values) => {
        this.setState({ loading: true })
        return axios.post('/register', {
            posicion: 'Cliente',
            tipo: 4,
            ...values
        })
            .then(({ data, headers }) => {
                const { setUser } = this.props;
                axios.defaults.headers.post["Authorization"] = headers.authorization;
                sessionStorage.setItem('token', headers.authorization);
                axios.defaults.headers.common['Authorization'] = sessionStorage.getItem('token');
                setUser(data.data);
                this.redirectTo('/admin/dashboard');
            })
            .catch(({ response }) => {

                let message = response?.data?.error || "Ocurrió un error inesperado.";
                Modal.error({
                    title: "No se ha podido registrar.",
                    content: <>
                    {message} <br />
                    ¿Ya se registró previamente? <a onClick={() => this.setState({ modalRegisterVisible: true })}> Recupera tu contraseña</a>
                    </>
                })
            })
            .finally(f => {
                this.setState({ loading: false });
            })
    }

    /**
     * @memberof Register
     *
     * @method renderRedirect
     * @description  Activa el redireccionamiento si el formulario se envio con exito
     *
     **/
    renderRedirect = () => {
        if (this.state.log)
            return <Redirect to={this.redirectLink} />
    };


    /**
     * @memberof Register
     *
     * @method redirectTo
     * @description  Redirecciona a cierto link.
     *
     **/
    redirectTo = (to) => {
        this.redirectLink = to;
        this.setState({ log: true });
    };


    hideModal = () => {
        this.setState({
            modalRegisterVisible: false
        })
    }





    render() {
        return (
            <Spin spinning={this.state.loading}>
                {this.renderRedirect()}
                <Row gutter={[8, 0]} style={{ height: 'calc(100vh)', overflowY: 'auto', background: "url('images/bg-1.jpg')", backgroundSize: "cover" }} justify='center' align='middle' >
                    <Col span={24} flex="auto">
                        <Row justify="center" gutter={[0, 0]} align="middle" className='pd-1'>
                            <Col xs={{ span: 22 }} sm={{ span: 20 }} md={{ span: 18 }} lg={{ span: 14 }} xl={{ span: 11 }} xxl={{ span: 9 }} >
                                {this.state.error?.success == false ?
                                    <Alert
                                        message="¡Ha ocurrido un error!"
                                        description={this.state.error.message}
                                        type="error"
                                        closable
                                        className="pd-1 mb-1"

                                        onClose={() => this.setState({ error: { success: null, description: null } })}

                                    />
                                    : null}
                                <Card className='login login-card mb-1' bordered={false}>
                                    <div className="login-header">
                                        <h3 className="h3-title login-title">Crear cuenta</h3>
                                        <Text className="login-subtitle">Completa tus datos para registrarte</Text>
                                    </div>
                                    <Form
                                        onFinish={this.handleSubmit}
                                        layout={"vertical"}
                                        requiredMark={false}
                                        className="login-form"
                                    >
                                        <Row gutter={[16, 0]}>
                                            <Col xs={24} md={12}>
                                                <Form.Item
                                                    label="Nombre"
                                                    name="nombre"
                                                    rules={[
                                                        { required: true, message: 'Por favor ingresa tu nombre' }
                                                    ]}>
                                                    <Input
                                                        placeholder="Nombre(s)"
                                                        size="large"
                                                        className="login-input"
                                                        prefix={<UserOutlined className="login-input-icon" />}
                                                        autoComplete="given-name"
                                                    />
                                                </Form.Item>
                                            </Col>
                                            <Col xs={24} md={12}>
                                                <Form.Item
                                                    label="Apellidos"
                                                    name="apellido"
                                                    rules={[
                                                        { required: true, message: 'Por favor ingresa tus apellidos' }
                                                    ]}>
                                                    <Input
                                                        placeholder="Apellido(s)"
                                                        size="large"
                                                        className="login-input"
                                                        prefix={<UserOutlined className="login-input-icon" />}
                                                        autoComplete="family-name"
                                                    />
                                                </Form.Item>
                                            </Col>
                                            <Col xs={24} md={12}>
                                                <Form.Item
                                                    name="email"
                                                    label="Correo electrónico"
                                                    rules={[
                                                        { required: true, message: 'Por favor ingresa tu correo' },
                                                        { type: 'email', message: 'Ingresa un correo válido' }
                                                    ]}>
                                                    <Input
                                                        placeholder="correo@ejemplo.com"
                                                        size="large"
                                                        className="login-input"
                                                        prefix={<MailOutlined className="login-input-icon" />}
                                                        autoComplete="email"
                                                    />
                                                </Form.Item>
                                            </Col>
                                            <Col xs={24} md={12}>
                                                <Form.Item
                                                    label="Teléfono"
                                                    name="telefono"
                                                    rules={[
                                                        { required: true, message: 'Por favor ingresa tu teléfono' }
                                                    ]}>
                                                    <Input
                                                        placeholder="+526647947439"
                                                        size="large"
                                                        className="login-input"
                                                        prefix={<PhoneOutlined className="login-input-icon" />}
                                                        autoComplete="tel"
                                                    />
                                                </Form.Item>
                                            </Col>
                                            <Col xs={24} md={12}>
                                                <Form.Item
                                                    name="razon_social"
                                                    label={<>Empresa / Razón Social <span className="login-optional">(opcional)</span></>}
                                                >
                                                    <Input
                                                        placeholder="Persona Moral / Física"
                                                        size="large"
                                                        className="login-input"
                                                        prefix={<BankOutlined className="login-input-icon" />}
                                                        autoComplete="organization"
                                                    />
                                                </Form.Item>
                                            </Col>
                                            <Col xs={24} md={12}>
                                                <Form.Item
                                                    name="departamento"
                                                    label={<>Departamento <span className="login-optional">(opcional)</span></>}
                                                >
                                                    <Input
                                                        placeholder="Área"
                                                        size="large"
                                                        className="login-input"
                                                        prefix={<ApartmentOutlined className="login-input-icon" />}
                                                    />
                                                </Form.Item>
                                            </Col>
                                            <Col xs={24} md={12}>
                                                <Form.Item
                                                    label="Contraseña"
                                                    name="password"
                                                    rules={[
                                                        {
                                                            required: true,
                                                            message: 'Por favor ingresa tu contraseña'
                                                        },
                                                        {
                                                            min: 8,
                                                            message: 'La contraseña debe de tener mínimo 8 caracteres'
                                                        },
                                                        {
                                                            pattern: new RegExp("^(?=.*[0-9])(?=.*[a-z]|[A-Z]).+$"),
                                                            message: 'Debe tener números y letras en mayusculas y minusculas'
                                                        },
                                                    ]}>
                                                    <Input.Password
                                                        placeholder="Mínimo 8 caracteres"
                                                        size="large"
                                                        className="login-input"
                                                        prefix={<LockOutlined className="login-input-icon" />}
                                                        autoComplete="new-password"
                                                    />
                                                </Form.Item>
                                            </Col>
                                            <Col xs={24} md={12}>
                                                <Form.Item
                                                    name="password_confirmation"
                                                    label="Confirmar contraseña"
                                                    dependencies={['password']}
                                                    rules={[
                                                        {
                                                            required: true,
                                                            message: 'Debe de confirmar su contraseña',
                                                        },
                                                        ({ getFieldValue }) => ({
                                                            validator(_, value) {
                                                                if (!value || getFieldValue('password') === value) {
                                                                    return Promise.resolve();
                                                                }
                                                                return Promise.reject(new Error('Las contraseñas no coinciden'));
                                                            },
                                                        }),
                                                    ]}
                                                >
                                                    <Input.Password
                                                        placeholder="Repite tu contraseña"
                                                        size="large"
                                                        className="login-input"
                                                        prefix={<LockOutlined className="login-input-icon" />}
                                                        autoComplete="new-password"
                                                    />
                                                </Form.Item>
                                            </Col>
                                        </Row>
                                        <Form.Item
                                            className='w-100 register-captcha'
                                            name="captcha"
                                            rules={[
                                                {
                                                    required: true,
                                                    message: 'Indique el CAPTCHA',
                                                },
                                            ]}
                                        >
                                            <ReCAPTCHA
                                                size="normal"
                                                sitekey={process.env.REACT_APP_GOOGLE_CAPTCHA}
                                            />
                                        </Form.Item>
                                        <Form.Item style={{ marginBottom: 0, marginTop: 16 }}>
                                            <Button type="primary" htmlType="submit" block size="large" className="button-login login-button">Crear cuenta</Button>
                                        </Form.Item>
                                    </Form>
                                    <Divider plain className="login-divider">¿Ya tienes cuenta?</Divider>
                                    <div className="login-register">
                                        <Text type="secondary">¿Ya estás registrado? </Text>
                                        <Link to="/login" className="login-link">Inicia sesión aquí</Link>
                                    </div>
                                </Card>

                            </Col>
                        </Row>
                    </Col>
                </Row>
                <Recovery
                    visible={this.state.modalRegisterVisible}
                    hideModal={this.hideModal}
                />
            </Spin>
        )
    }
}



export default function (props) {

    let user = useContext(User)
    const setUser = useContext(SetUser)

    return <Register {...props} user={user} setUser={setUser} />
}